export enum SEED_NUMBER_POLICY {
  DETERMINISTIC = 0,
  STOCHASTIC = 10,
  AREA_BASED = 20,
}

export const RegularityThresholds = {
  HARD_PARCEL: 0.45,
  EASY_PARCEL: 0.7,
};

export const GabaritVisualisation = {
  /* Experimental, to remove */
  NONE: 0,
  FALSY: 1,
  ALL: 2,
};

export const PLUFlags: {
  seedNumberPolicy: SEED_NUMBER_POLICY;
  setBack3D: boolean;
  simplificationPostProcess: boolean;
} = {
  seedNumberPolicy: SEED_NUMBER_POLICY.STOCHASTIC,
  setBack3D: true,
  simplificationPostProcess: true,
};

export const ReactionFlags = {
  underEnvelope: true,
  setBack3D: true,
  extendsNeighbourFacade: true,
  setBackInSequence: true,
  continueWithConstructiveWhenShobIsLow: false,
  minHeightReaction: true,
  facadesSetBack: true,
  removeWindows: true,
  maxHeightLimit: true,
  lastLevelSetback: true,
  lastLevelSetbackProportion: true,
};

export const DeformationFlags = {
  alwasTryRoof: true,
};

export const SplitParcelByZonesFlag = false;
